


































































































import { General } from "@/services/General";
import axios from "axios";
import { Component, Vue, Prop } from "vue-property-decorator";
import { UserProfileDto } from "@/interfaces/userProfileDto";
import { DropDownItem } from "@/services/DropDownItem";

@Component
export default class ExternalUserInfo extends Vue {       
    @Prop()
    userProfileProp: UserProfileDto;
    
    dropDownCountries: Array<any> = null;
    dropDownRoles: Array<any> = null;
    userProfile: UserProfileDto = {} as UserProfileDto;

    loading: boolean = false;
    rolesLoaded: boolean = false;
    isSaveClicked: boolean = false;
    editMode: boolean = false;
    lockedOut: boolean = false;

    async mounted() {
        this.loading = true;
        
        this.dropDownCountries = await this.getDropdownCountries();
        this.dropDownRoles = await this.getDropdownRoles();
        if(this.userProfileProp != null) {
            this.userProfile = this.userProfileProp;
            this.editMode = true;

            this.lockedOut = await this.IsLockedOutUser();
        }

        this.rolesLoaded = true;
        this.loading = false;
    }

    setBtnSaveLabel() {
        if(this.editMode) {
            return "Update user Info"
        } else {
            return "Create user"
        }
    }

    getContractTypeDescription(contractType: number) {
        return General.getContractTypeDescription(contractType);
    }

    async getDropdownCountries(): Promise<Array<any>> {
        try {
            let country: DropDownItem = new DropDownItem();
            let countryList: DropDownItem[] = [];

            let response = await axios.get<any[]>(
                General.GetApiUrl('/api/Culture/GetCountriesAll'), {
                responseType: "json",
                withCredentials: true
            });

            if (response.data) {
                response.data.forEach(element => {
                    country = new DropDownItem();
                    country.idDropDownItem = element.idCountry;
                    country.itemText = element.name;

                    countryList.push(country);
                });
                return General.SetOptionsDropDown(countryList);
            }
        } catch (ex) {
            General.HandleError(ex, this);
            return null;
        }
    }

    async getDropdownRoles(): Promise<Array<any>> {
        try {
            let role: DropDownItem = new DropDownItem();
            let roleList: DropDownItem[] = [];

            let response = await axios.get<any[]>(
                General.GetApiUrl('/api/Admin/GetAllRoles'), {
                responseType: "json",
                withCredentials: true
            });

            if (response.data) {
                response.data.forEach(element => {
                    role = new DropDownItem();
                    role.idDropDownItem = element.id;
                    role.itemText = element.name;

                    roleList.push(role);
                });
                
                return General.SetOptionsDropDown(roleList);
            }
        } catch (ex) {
            General.HandleError(ex, this);
            return null;
        }
    }

    async onClickSaveButton() {
        if(this.editMode) {
            await this.updateUserConfirm();
        } else {
            await this.createUserConfirm();
        }
    }

    async createUserConfirm() {           
        this.isSaveClicked = true;
        if(this.isValidForm()) {
            General.confirm(
                'Do you confirm ' + this.userProfile.Email + ' as e-mail? An e-mail will be sent to this address to allow user to set login password',
                this,
                async () => {
                    await this.createUser();
                }
            );
        }
    }

    async createUser() {    
        this.loading = true;

        await axios({
            method: 'post',
            url: General.GetApiUrl('/api/Admin/CreateExternalUser'),
            data: this.userProfile,
            withCredentials: true,
            responseType: 'json'
        }).then(response => {
            this.isSaveClicked = false;
            this.loading = false;
            this.$emit('onCreateExternalUserSuccess', this.userProfile.Email);
            General.showAlertSuccess(`${response.data.message} on (${response.data.username})`, this);
        }).catch(error => {
            this.loading = false;
            if (error.response) {
                General.showAlertDanger(error.response.data.message, this)
            }
            else {
                General.showAlertDanger("No response was received", this)
            }
        });
    }

    async updateUserConfirm() {
        this.isSaveClicked = true;
        if(this.isValidForm()) {
            General.confirm(
                'Do you confirm user info update?',
                this,
                async () => {
                    await this.updateUser();
                }
            );
        }
    }

    async updateUser() {    
        this.loading = true;
        await axios({
            method: 'post',
            url: General.GetApiUrl('/api/Admin/UpdateExternalUser'),
            data: this.userProfile,
            withCredentials: true,
            responseType: 'json'
        }).then(response => {
            this.isSaveClicked = false;
            this.loading = false;

            General.showAlertSuccess('Update done successfully', this);
        }).catch(error => {
            this.loading = false;
            General.HandleError(error, this);
        });
    }

    async setIsActiveUserConfirm() {
        let message: string = 'User will be ' + (this.userProfile.IsActive ? 'disabled' : 'enabled') + ' to access on ePli. Confirm?'
        General.confirm(
            message,
            this,
            async () => {
                await this.setIsActiveUser();
            }
        );
    }

    async setIsActiveUser() {    
        this.loading = true;
        await axios({
            method: 'get',
            url: General.GetApiUrl('/api/Admin/SetIsActiveUser'),
            params: {
                idUser: this.userProfile.IdUser,
                isActive: !this.userProfile.IsActive
            },
            withCredentials: true,
            responseType: 'json'
        }).then(response => {
            this.loading = false;
            this.userProfile.IsActive = !this.userProfile.IsActive;
            General.showAlertSuccess('User ' + (!this.userProfile.IsActive ? 'disabled' : 'enabled') + ' successfully', this);
        }).catch(error => {
            this.loading = false;
            General.HandleError(error, this);
        });
    }

    async unlockUserConfirm() {
        let message: string = 'User will be unlocked. Confirm?'
        General.confirm(
            message,
            this,
            async () => {
                await this.unlockUser();
            }
        );
    }

    async unlockUser() {    
        this.loading = true;
        await axios({
            method: 'get',
            url: General.GetApiUrl('/api/Admin/UnlockUser'),
            params: {
                username: this.userProfile.Username
            },
            withCredentials: true,
            responseType: 'json'
        }).then(response => {
            this.loading = false;
            this.lockedOut = false;
            General.showAlertSuccess('User unlocked successfully', this);
        }).catch(error => {
            this.loading = false;
            General.HandleError(error, this);
        });
    }

    async IsLockedOutUser() {
        let response = await axios({
            method: 'get',
            url: General.GetApiUrl('/api/Admin/IsLockedOutUser'),
            params: {
                username: this.userProfile.Username
            },
            withCredentials: true,
            responseType: 'json'
        })
        if(response) {
            return response.data;
        }
        return false;
    }

    async resetPasswordConfirm() {
        General.confirm(
            'Do you confirm sending reset password request?',
            this,
            async () => {
                await this.resetPassword();
            }
        );
    }

    async resetPassword() {    
        this.loading = true;
        await axios({
            method: 'post',
            url: General.GetApiUrl('/api/auth/ResetPasswordRequest?username=' + this.userProfile.Email),
            withCredentials: true,
            responseType: 'json'
        }).then(response => {
            this.loading = false;

            General.showAlertSuccess('Reset password request send successfully', this);
        }).catch(error => {
            this.loading = false;
            General.HandleError(error, this);
        });
    }


    returnState(condition: boolean, clickButton: boolean): boolean {
        if (clickButton) 
            return condition;
        else 
            return null;
    }

    isValidForm() {
        let isValid: boolean = true;
        if(this.CheckIsNullOrEmpty(this.userProfile.Email)
            || this.CheckIsNullOrEmpty(this.userProfile.Name)
            || this.CheckIsNullOrEmpty(this.userProfile.Surname)
            || this.CheckIsNullOrEmpty(this.userProfile.IdCountry)) {
            isValid = false;
        }
        return isValid
    }
    
    CheckIsNullOrEmpty(text: any) {
        if (text == null) return true;
        if (text.toString() === '') return true;
        return false;
    }
}
